export const QRRoutes = {
    permissions: '/',
    accessOptions: '/access-options/',
    callTenant: '/call-tenant/',
    pinCode: '/pin-code/',
    packageScan: '/package-scan/',
};
